module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/th/3/1-debe217fd9b1458d0fea71632bf654c4.jpg";